import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  fill: "none",
  "aria-label": "AI thinking sparkles",
  class: "ai-sparkles",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m16 22 2 4 4 2-4 2-2 4-2-4-4-2 4-2Z",
      class: "sparkle small"
    }, null, -1),
    _createElementVNode("path", {
      d: "m32 10 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z",
      class: "sparkle medium"
    }, null, -1),
    _createElementVNode("path", {
      d: "m44 30 4 8 8 4-8 4-4 8-4-8-8-4 8-4Z",
      class: "sparkle large"
    }, null, -1)
  ])))
}
export default { render: render }